///<reference path="../libs/info/imagelogic/Ajax.ts"/>
///<reference path="model/TideTime.ts"/>
///<reference path="model/TideName.ts"/>
///<reference path="model/Sunrise.ts"/>
///<reference path="view/ChosekiView.ts"/>
///<reference path="model/Warn.ts"/>
///<reference path="view/WarnView.ts"/>

namespace app{
	import getJSON = info.imagelogic.Ajax.getJSON;
	import Warn = app.model.Warn;
	import WarnView = app.view.WarnView;
	const pathToWarn:string = '../wnidata/wni/warn.json';

	export class WarnDoc{

		constructor(){
			let dataArea = document.getElementById("dataArea");

			let warn:Warn = new Warn();

			let view:WarnView = new WarnView();
			view.warnData = warn;
			//

			let promises = [
				getJSON(pathToWarn).then((data) => {
					warn.parseData(data);
				}).catch(console.log)
			];

			Promise.all(promises).then(() => {
				// console.log("finish all");
				dataArea.innerHTML = view.makeData();
			}).catch(() => {
				// console.log("something wrong");
				dataArea.innerHTML = view.makeError();
			});
		}
	}
}